import StackedBar from "libs/preact-chart/StackedBar";
// import bgColors from "./colorsBg";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: "y",
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      stacked: true,
      display: false,
    },
    y: {
      stacked: true,
      display: false,
    },
  },
};

function StackedBarChart({ _, data, refName }) {
  let height = 50;
  if (window.innerWidth < 400) {
    height = 220;
  }
  return (
    <StackedBar
      refName={refName}
      data={data}
      options={options}
      height={height}
    />
  );
}

export default StackedBarChart;
